import { SIGNATURE_ENUM } from '@/shared/config';
import { t } from 'ttag';

const OPTIONS_SIGNATURE = [
  {
    value: SIGNATURE_ENUM.STANDARD,
    label: t`Anyone can sign (Cost $2.00+)`,
  },
  {
    value: SIGNATURE_ENUM.ADULT,
    label: t`An adult must sign (Cost $5.00+)`,
  },
];

export { OPTIONS_SIGNATURE };
